import Header from "../Protected/Header";
import Footer from "../Common/Footer";
import Scripts from "../Common/Scripts/Scripts";
import one from "../../images/background/1.jpg";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { get } from "../../api";
import Comments from "./Comments";
import "./BlogDetail.css";

function BlogDetail() {
  const [searchParams] = useSearchParams();
  const [blogDetail, setBlogDetail] = useState({});
  const blogId = searchParams.get("id");

  useEffect(() => {
    getBlogDetail();
  }, []);

  const getBlogDetail = async () => {
    try {
      const url = `user/blog/${blogId}`;
      let response = await get(url);
      if (response) {
        setBlogDetail(response);
      }
    } catch (e) {
      console.error("Error fetching blog details");
    }
  };

  return (
    <div className="page-wrapper bg-light">
      <Scripts />
      <Header />
      
      {/* Page Title */}
      

      {/* Blog Content Section */}
      <section className="blog-content py-5">
        <div className="container">
        <section className="text-white py-5 text-center">
       &nbsp;
      </section>
          <div className="card shadow-lg p-4">
            <div className="card-body">
              <h2 className="card-title text-center text-secondary mb-4">
              {blogDetail?.title}
              </h2>
              <p
                className="card-text fs-5 lh-lg text-dark border-bottom pb-4"
                dangerouslySetInnerHTML={{
                  __html: blogDetail?.description,
                }}
              ></p>
              {/* Comments Section */}
              <div className="comments mt-4">
                <h4 className="text-secondary">Comments</h4>
                <Comments
                  comments={blogDetail?.blogComments || []}
                  blogDetail={blogDetail}
                  getBlogDetail={getBlogDetail}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section
        className="call-to-action-two text-white text-center py-5"
        style={{
          backgroundImage: `url(${one})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <h2 className="display-4 mb-4">Let's Get Going!</h2>
          <a
            href="/#/jobList"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-lg btn-warning shadow-sm text-uppercase fw-bold"
          >
            Search Job
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BlogDetail;
